var _path, _path2, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "47 42 769 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M815.301 63.6992H47.3008V55.223H392.94C395.926 55.223 398.664 53.5593 400.04 50.9083L402.061 47.0139C403.437 44.363 406.175 42.6992 409.162 42.6992H453.44C456.426 42.6992 459.164 44.363 460.54 47.0139L462.561 50.9083C463.937 53.5593 466.675 55.223 469.662 55.223H815.301V63.6992Z",
    fill: "#0057FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3008 62.6992V56.2227H392.939C396.299 56.2227 399.38 54.3514 400.928 51.3691L402.949 47.4746C404.153 45.1551 406.549 43.6992 409.162 43.6992H453.439C456.053 43.6992 458.448 45.1551 459.652 47.4746L461.674 51.3691C463.222 54.3514 466.302 56.2227 469.662 56.2227H814.301V62.6992H48.3008Z",
    stroke: "url(#paint0_linear_18843_3289)",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 420.301,
    y: 49.6992,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18843_3289",
    x1: 448.367,
    y1: 43.2255,
    x2: 448.367,
    y2: 50.1729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363FBC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartUp);
export default __webpack_public_path__ + "static/media/cart-up.cb97eaafa081f4003c7df93a4b46cb91.svg";
export { ForwardRef as ReactComponent };